import { Container, FloatingLabel, Form, Modal } from 'react-bootstrap';
import { FC, useMemo, useState } from 'react';
import { generalHelpers, initialPhoneNumber } from '@monorepo/helpers';
import { hideLoadingModalReducer, setValuesAndOpenAlertModalReducer, showLoadingModalReducer } from 'src/store';
import { typeUser } from '@monorepo/models';
import { useDispatch } from 'react-redux';
import { useGetIsDarkMode, useGetIsMobile } from 'src/custom-hooks';
import { userServices } from 'src/services';

type propsType = {
    closeModal: () => void;
    currentUser: typeUser;
};

export const UsersPersonalDataModal: FC<propsType> = ({ closeModal, currentUser }) => {
    const [errorMessage, setErrorMessage] = useState('');
    const [lastName, setLastName] = useState(currentUser.lastName ?? '');
    const [name, setName] = useState(currentUser.name ?? '');
    const [phoneNumber, setPhoneNumber] = useState(currentUser.phoneNumber || initialPhoneNumber);
    const dispatch = useDispatch();
    const isDarkMode = useGetIsDarkMode();
    const isMobile = useGetIsMobile();

    const isValid: boolean = useMemo(() =>
        lastName.length < 20
        && name.length < 20
        && (phoneNumber === '' || phoneNumber.includes('***') || generalHelpers.IsValidPhoneNumber(phoneNumber) || phoneNumber === initialPhoneNumber)
        && (lastName !== (currentUser.lastName ?? '') || name !== (currentUser.name ?? '') || (phoneNumber !== '+54911' && phoneNumber !== (currentUser.phoneNumber ?? '')))
    , [currentUser, lastName, name, phoneNumber]);

    const save = () => {
        if (!isValid) {
            return;
        }
        setErrorMessage('');
        dispatch(setValuesAndOpenAlertModalReducer({
            title: 'Confirmar',
            message: `Se guardarán los datos del usuario ${currentUser.email}: nombre ${name || '(vacío)'}, apellido ${lastName || '(vacío)'} y teléfono ${!!phoneNumber && phoneNumber !== '+54911' ? phoneNumber : '(vacío)'}`,
            mode: 'confirm',
            animation: 3,
            execution: async () => {
                dispatch(showLoadingModalReducer());
                const response = await userServices.SetPersonalData(currentUser.id, name, lastName, phoneNumber && phoneNumber !== initialPhoneNumber ? phoneNumber : '');
                dispatch(hideLoadingModalReducer());
                if (!response.success) {
                    setErrorMessage(`${response.message.title} | ${response.message.description}`);
                    return;
                }
                closeModal();
            }
        }));
    }

    return (
        <Modal show size={'lg'} fullscreen={'md-down'} onHide={closeModal}>
            <Modal.Header className={isDarkMode ? 'bg-dark text-white' : ''} closeButton>
                <Modal.Title>
                    Datos personales de {currentUser.email}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className={isDarkMode ? 'bg-dark' : ''}>
                <Container style={{ maxWidth: '500px', padding: isMobile ? '35px 30px 0' : '35px 0 0' }}>
                    <FloatingLabel className={'mb-3 text-dark'}
                        label={'Nombre'}
                    >
                        <Form.Control type={'text'}
                            className={'form-control'}
                            placeholder={''}
                            value={name}
                            onChange={e => e.target.value.length < 20 ? setName(e.target.value) : null}
                            autoFocus
                        />
                    </FloatingLabel>
                    <FloatingLabel className={'mb-3 text-dark'}
                        label={'Apellido'}
                    >
                        <Form.Control type={'text'}
                            className={'form-control'}
                            placeholder={''}
                            value={lastName}
                            onChange={e => e.target.value.length < 20 ? setLastName(e.target.value) : null}
                            onKeyDown={e => e.key === 'Enter' ? save() : null}
                        />
                    </FloatingLabel>
                    <FloatingLabel
                        className={'mb-3 text-dark'}
                        label={"Teléfono celular"}
                    >
                        <Form.Control
                            type={'text'}
                            className={'form-control'}
                            placeholder={""}
                            value={phoneNumber}
                            onChange={e => {
                                const v = e.target.value.split(' ').join('').split('-').join('');
                                if (v.includes('***')) {
                                    setPhoneNumber('');
                                    return;
                                }
                                setPhoneNumber(v);
                            }}
                            onKeyDown={e => e.key === 'Enter' ? save() : null}
                        />
                    </FloatingLabel>
                    <div className={isDarkMode ? 'text-white' : ''}>
                        Para que funcionen las notificaciones automáticas el formato de los números debe ser rigurosamente correcto según E.164: sin espacios, comenzando con signo + y con código de país, de tipo y de área (para Buenos Aires +54911 y 8 números más)
                    </div>
                    {errorMessage &&
                        <div className={'bg-danger text-white p-2 mt-2'}>
                            {errorMessage}
                        </div>
                    }
                    <button className={'btn btn-general-blue d-block w-100 mt-4'}
                        style={{ fontWeight: 'bolder', height: '50px' }}
                        onClick={save}
                        disabled={!isValid}
                    >
                        GUARDAR
                    </button>
                    <button className={`btn btn-general-red d-block w-100 mt-2 mb-3`}
                        style={{ fontWeight: 'bolder', height: '50px' }}
                        onClick={closeModal}
                    >
                        CANCELAR
                    </button>
                </Container>
            </Modal.Body>
        </Modal>
    );
}
